import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import QRCode from 'qrcode';


const MapPopupQRCode = ({ plantation }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [qrCodeData, setQrCodeData] = useState('');
  const [loading, setLoading] = useState(true);
  const APP_BASE_URL = process.env.REACT_APP_URL;

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        if (!plantation._id) return;
        
        const qrCodeUrl = `${APP_BASE_URL}/plantation/pdf/${plantation._id}`;
        const qrCodeData = await QRCode.toDataURL(qrCodeUrl, { 
          width: 80,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        setQrCodeUrl(qrCodeUrl);
        setQrCodeData(qrCodeData);
      } catch (error) {
        console.error('Error generating QR code:', error);
      } finally {
        setLoading(false);
      }
    };

    generateQRCode();
  }, [plantation, APP_BASE_URL]);

  if (loading) {
    return (
      <div className="qr-code-loading">
        <Icon icon="eos-icons:loading" width="20" height="20" />
      </div>
    );
  }

  return (
    <div className="qr-code-section">
     
        {qrCodeUrl && (
                  <a
                    href={qrCodeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit'
                    }}
                  >
                    <div
                      style={{
                        width: '100px',
                        height: '100px',
                        background: 'white',
                        padding: '8px',
                        borderRadius: '6px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        flexShrink: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        cursor: 'pointer',
                        ':hover': {
                          transform: 'scale(1.05)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                        }
                      }}
                    >
                      <img
                        src={qrCodeData}
                        alt="Complaint QR Code"
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'contain',
                          maxWidth: '100%',
                          maxHeight: '100%'
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '';
                          e.target.parentElement.style.display = 'flex';
                          e.target.parentElement.innerHTML = `
                            <div style="text-align: center; padding: 10px;">
                              <div style="font-size: 14px; margin-bottom: 8px;">QR Code Error</div>
                              <div style="font-size: 12px; color: #666;">Click to view complaint</div>
                            </div>`;
                        }}
                      />
                    </div>
                  </a>
                )}
                 
      <div className="qr-code-note">Scan or Click for details</div>
    </div>
  );
};

export default MapPopupQRCode;